import styled from 'styled-components';
export var StyledText = styled.p.withConfig({
  displayName: "Textstyled__StyledText",
  componentId: "sc-ze3yye-0"
})(["margin:0 0 1rem;font-size:var(--dentsu-font-size-14);color:var(--dentsu-color-black);font-weight:300;"]);